/**
 * Generated by orval v8.4.1 🍺
 * Do not edit manually.
 * Supabase API (v1)
 * Supabase API generated from the OpenAPI specification.<br>Visit [https://supabase.com/docs](https://supabase.com/docs) for a complete documentation.
 * OpenAPI spec version: 1.0.0
 */
import type {
  AnalyticsResponse,
  V1GetProjectFunctionCombinedStatsParams,
  V1GetProjectLogsParams,
  V1GetProjectUsageApiCountParams,
  V1GetUsageApiCountResponse,
  V1GetUsageApiRequestsCountResponse
} from './supabaseAPIV1.schemas';

import { customFetch } from '../fetcher';


/**
 * Executes a SQL query on the project's logs.

Either the `iso_timestamp_start` and `iso_timestamp_end` parameters must be provided.
If both are not provided, only the last 1 minute of logs will be queried.
The timestamp range must be no more than 24 hours and is rounded to the nearest minute. If the range is more than 24 hours, a validation error will be thrown.

Note: Unless the `sql` parameter is provided, only edge_logs will be queried. See the [log query docs](/docs/guides/telemetry/logs?queryGroups=product&product=postgres&queryGroups=source&source=edge_logs#querying-with-the-logs-explorer:~:text=logs%20from%20the-,Sources,-drop%2Ddown%3A) for all available sources. 

 * @summary Gets project's logs
 */
export type v1GetProjectLogsResponse200 = {
  data: AnalyticsResponse
  status: 200
}

export type v1GetProjectLogsResponse401 = {
  data: void
  status: 401
}

export type v1GetProjectLogsResponse403 = {
  data: void
  status: 403
}

export type v1GetProjectLogsResponse429 = {
  data: void
  status: 429
}

export type v1GetProjectLogsResponseSuccess = (v1GetProjectLogsResponse200) & {
  headers: Headers;
};
export type v1GetProjectLogsResponseError = (v1GetProjectLogsResponse401 | v1GetProjectLogsResponse403 | v1GetProjectLogsResponse429) & {
  headers: Headers;
};

export type v1GetProjectLogsResponse = (v1GetProjectLogsResponseSuccess | v1GetProjectLogsResponseError)

export const getV1GetProjectLogsUrl = (ref: string,
    params?: V1GetProjectLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/projects/${ref}/analytics/endpoints/logs.all?${stringifiedParams}` : `/v1/projects/${ref}/analytics/endpoints/logs.all`
}

export const v1GetProjectLogs = async (ref: string,
    params?: V1GetProjectLogsParams, options?: RequestInit): Promise<v1GetProjectLogsResponse> => {
  
  return customFetch<v1GetProjectLogsResponse>(getV1GetProjectLogsUrl(ref,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Gets project's usage api counts
 */
export type v1GetProjectUsageApiCountResponse200 = {
  data: V1GetUsageApiCountResponse
  status: 200
}

export type v1GetProjectUsageApiCountResponse401 = {
  data: void
  status: 401
}

export type v1GetProjectUsageApiCountResponse403 = {
  data: void
  status: 403
}

export type v1GetProjectUsageApiCountResponse429 = {
  data: void
  status: 429
}

export type v1GetProjectUsageApiCountResponse500 = {
  data: void
  status: 500
}

export type v1GetProjectUsageApiCountResponseSuccess = (v1GetProjectUsageApiCountResponse200) & {
  headers: Headers;
};
export type v1GetProjectUsageApiCountResponseError = (v1GetProjectUsageApiCountResponse401 | v1GetProjectUsageApiCountResponse403 | v1GetProjectUsageApiCountResponse429 | v1GetProjectUsageApiCountResponse500) & {
  headers: Headers;
};

export type v1GetProjectUsageApiCountResponse = (v1GetProjectUsageApiCountResponseSuccess | v1GetProjectUsageApiCountResponseError)

export const getV1GetProjectUsageApiCountUrl = (ref: string,
    params?: V1GetProjectUsageApiCountParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/projects/${ref}/analytics/endpoints/usage.api-counts?${stringifiedParams}` : `/v1/projects/${ref}/analytics/endpoints/usage.api-counts`
}

export const v1GetProjectUsageApiCount = async (ref: string,
    params?: V1GetProjectUsageApiCountParams, options?: RequestInit): Promise<v1GetProjectUsageApiCountResponse> => {
  
  return customFetch<v1GetProjectUsageApiCountResponse>(getV1GetProjectUsageApiCountUrl(ref,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Gets project's usage api requests count
 */
export type v1GetProjectUsageRequestCountResponse200 = {
  data: V1GetUsageApiRequestsCountResponse
  status: 200
}

export type v1GetProjectUsageRequestCountResponse401 = {
  data: void
  status: 401
}

export type v1GetProjectUsageRequestCountResponse403 = {
  data: void
  status: 403
}

export type v1GetProjectUsageRequestCountResponse429 = {
  data: void
  status: 429
}

export type v1GetProjectUsageRequestCountResponse500 = {
  data: void
  status: 500
}

export type v1GetProjectUsageRequestCountResponseSuccess = (v1GetProjectUsageRequestCountResponse200) & {
  headers: Headers;
};
export type v1GetProjectUsageRequestCountResponseError = (v1GetProjectUsageRequestCountResponse401 | v1GetProjectUsageRequestCountResponse403 | v1GetProjectUsageRequestCountResponse429 | v1GetProjectUsageRequestCountResponse500) & {
  headers: Headers;
};

export type v1GetProjectUsageRequestCountResponse = (v1GetProjectUsageRequestCountResponseSuccess | v1GetProjectUsageRequestCountResponseError)

export const getV1GetProjectUsageRequestCountUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/analytics/endpoints/usage.api-requests-count`
}

export const v1GetProjectUsageRequestCount = async (ref: string, options?: RequestInit): Promise<v1GetProjectUsageRequestCountResponse> => {
  
  return customFetch<v1GetProjectUsageRequestCountResponse>(getV1GetProjectUsageRequestCountUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Gets a project's function combined statistics
 */
export type v1GetProjectFunctionCombinedStatsResponse200 = {
  data: AnalyticsResponse
  status: 200
}

export type v1GetProjectFunctionCombinedStatsResponse401 = {
  data: void
  status: 401
}

export type v1GetProjectFunctionCombinedStatsResponse403 = {
  data: void
  status: 403
}

export type v1GetProjectFunctionCombinedStatsResponse429 = {
  data: void
  status: 429
}

export type v1GetProjectFunctionCombinedStatsResponse500 = {
  data: void
  status: 500
}

export type v1GetProjectFunctionCombinedStatsResponseSuccess = (v1GetProjectFunctionCombinedStatsResponse200) & {
  headers: Headers;
};
export type v1GetProjectFunctionCombinedStatsResponseError = (v1GetProjectFunctionCombinedStatsResponse401 | v1GetProjectFunctionCombinedStatsResponse403 | v1GetProjectFunctionCombinedStatsResponse429 | v1GetProjectFunctionCombinedStatsResponse500) & {
  headers: Headers;
};

export type v1GetProjectFunctionCombinedStatsResponse = (v1GetProjectFunctionCombinedStatsResponseSuccess | v1GetProjectFunctionCombinedStatsResponseError)

export const getV1GetProjectFunctionCombinedStatsUrl = (ref: string,
    params: V1GetProjectFunctionCombinedStatsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/projects/${ref}/analytics/endpoints/functions.combined-stats?${stringifiedParams}` : `/v1/projects/${ref}/analytics/endpoints/functions.combined-stats`
}

export const v1GetProjectFunctionCombinedStats = async (ref: string,
    params: V1GetProjectFunctionCombinedStatsParams, options?: RequestInit): Promise<v1GetProjectFunctionCombinedStatsResponse> => {
  
  return customFetch<v1GetProjectFunctionCombinedStatsResponse>(getV1GetProjectFunctionCombinedStatsUrl(ref,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

